import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Audit, AuditListPayload } from 'src/types/audit';
import * as thunks from './thunks';
import { NewPaginationMeta, PaginationLinks } from 'src/types';

type State = {
  audits: Audit[];
  auditParams?: AuditListPayload;
  isLoading: boolean;
  paginationMeta: {
    links: PaginationLinks;
    meta: NewPaginationMeta;
  };
};

const initialState: State = {
  audits: [],
  auditParams: {},
  isLoading: false,
  paginationMeta: {
    links: {},
    meta: {}
  }
};

const slice = createSlice({
  name: 'audits',
  initialState,
  reducers: {
    auditFilterParams(state, action: PayloadAction<AuditListPayload>) {
      state.auditParams = action.payload || {};
    }
  },
  extraReducers(builder) {
    builder.addCase(thunks.getAuditsThunk.fulfilled, (state, { payload }) => {
      state.audits = payload.originalData.audits;
    });

    builder.addCase(thunks.getAuditsThunkV2.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(thunks.getAuditsThunkV2.fulfilled, (state, { payload }) => {
      state.audits = payload?.originalData?.data;
      state.isLoading = false;
      state.paginationMeta={
        links:payload?.originalData?.links || {},
        meta:payload?.originalData?.meta || {}

      }
    });
    builder.addCase(thunks.getAuditsThunkV2.rejected, (state) => {
      state.isLoading = false;
    });
  }
});

export const reducer = slice.reducer;

export const actions = {
  ...slice.actions,
  ...thunks
};
